import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function DesiredURLStep({ formData, setFormData }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.desiredURL")}</h2>

      <div className="suffixed-input">
        <input
          ref={inputRef}
          type="text"
          value={formData.desiredURL}
          onChange={e =>
            setFormData({
              ...formData,
              desiredURL: e.target.value
                .toLowerCase()
                .replace(/\s+/g, "")
            })
          }

          placeholder="yourschool"
        />
        <span className="suffix">.dnzify.com</span>
      </div>

      <p className="muted">
        {`https://www.${formData.desiredURL || "yourschool"}.dnzify.com`}
      </p>
    </>
  );
}
